/* Viklund homepage hero crossfade.

   Loaded by sections/viklund-hero.liquid ONLY when the hero has two or more
   images, so a single-image hero costs nothing.

   Progressive enhancement, same contract as viklund.js: the first slide is
   already marked .is-active server-side and the scrim, heading and buttons never
   move, so if this script is blocked or fails the hero is a normal one-image
   hero rather than a blank box.

   Motion rules, both deliberate:
   - prefers-reduced-motion: reduce -> no rotation at all. Not a slower one.
   - Clicking a dot stops the rotation permanently. That is the WCAG 2.2.2
     mechanism for auto-updating content, and it is also what a person clicking
     a dot means: they want to look at that one.

   Rotation also holds while the tab is hidden, so a page left open in a
   background tab does not come back mid-fade on a slide nobody watched. */
(function () {
  if (window.vkHeroSlideshowInit) return;
  window.vkHeroSlideshowInit = true;

  var INTERVAL = 6000;

  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function setup(root) {
    if (!root || root.vkHeroBound) return;
    var slides = root.querySelectorAll('.hero__slide');
    if (slides.length < 2) return;
    root.vkHeroBound = true;

    var dots = root.querySelectorAll('[data-vk-hero-dot]');
    var index = 0;
    var timer = null;

    function show(next) {
      if (next === index) return;
      slides[index].classList.remove('is-active');
      slides[next].classList.add('is-active');
      if (dots[index]) dots[index].setAttribute('aria-current', 'false');
      if (dots[next]) dots[next].setAttribute('aria-current', 'true');
      index = next;
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      if (timer || reduced()) return;
      timer = setInterval(function () {
        show((index + 1) % slides.length);
      }, INTERVAL);
    }

    for (var i = 0; i < dots.length; i++) {
      (function (dot, target) {
        dot.addEventListener('click', function () {
          // Permanent: the visitor has taken control of the frame.
          stop();
          root.vkHeroHalted = true;
          show(target);
        });
      })(dots[i], i);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else if (!root.vkHeroHalted) {
        start();
      }
    });

    start();
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-vk-hero]');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor re-renders the section on every setting change, which produces
  // fresh nodes with no listeners and no timer.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
